import { inject } from 'inversify-props';
import IAuthService from 'services/IAuthService';
import { IFormatVersion, ICreativeCompilerResponse } from '@models';
import { AxiosPromise } from 'axios';

class FormatVersionService {
    @inject() private authService: IAuthService;

    host: string = `${window.location.protocol}//${window.location.host}`;
    api: string = '/api/formatversion/';

    constructor(api: string = null) {
        if (api) this.api = api;
    }

    formatVersionExists(formatVersion: IFormatVersion): AxiosPromise<boolean> {
        const endpoint = this.host + this.api + 'exists';
        const requestData = {
            id: formatVersion.id
        };

        return this.authService.post(endpoint, requestData);
    }

    saveFormatVersion(formatVersion: IFormatVersion): AxiosPromise<IFormatVersion> {
        const endpoint = this.host + this.api;

        return this.authService.post(endpoint, formatVersion);
    }

    getLastFormatVersion(formatId: string): AxiosPromise<IFormatVersion> {
        let queryString = new URLSearchParams();
        queryString.append("formatId", formatId);

        const endpoint = this.host + this.api + 'last' + '?' + queryString.toString();
        return this.authService.getV2(endpoint);
    }

    getSpecificFormatVersion(formatVersionId: string): AxiosPromise<IFormatVersion> {
        const endpoint = this.host + this.api + formatVersionId;
        return this.authService.getV2(endpoint);
    }

    validateFormatVersion(formatVersion: IFormatVersion): AxiosPromise<ICreativeCompilerResponse> {
        const endpoint = this.host + this.api + 'validate';
        return this.authService.post(endpoint, formatVersion);
    }


}

export default new FormatVersionService();
